// extracted by mini-css-extract-plugin
export var footer = "_9y_b7k";
export var footer_copy = "_9y_b8k";
export var footer_title = "_9y_b9k";